// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"516":"fe9dc5bc","523":"155143de","579":"311fbe70"}[chunkId] + ".chunk.css";
};